import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { ModalService } from '@shared/services/modal/modal.service';

@Component({
  standalone: false,
  selector: 'gstar-footer-modal',
  templateUrl: './footer-modal.component.html',
  styleUrls: ['./footer-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterModalComponent {
  private readonly modalService = inject(ModalService);

  @Input() id!: string;
  @Input() primaryButtonLabel: string = 'Confirm';
  @Input() secondaryButtonLabel: string = 'Cancel';
  @Input() primaryIconButton: string = '';
  @Input() secondaryIconButton: string = '';
  @Input() hidePrimaryButton?: boolean;
  @Input() hideSecondaryButton?: boolean;
  @Input() isEnabled: boolean = true;

  @Output() cancelEvent: EventEmitter<void> = new EventEmitter();
  @Output() confirmEvent: EventEmitter<void> = new EventEmitter();

  @ViewChild('footerContainer', { static: true })
  footerContainer?: ElementRef<HTMLElement>;

  get hasNotChildren(): boolean {
    return (
      !!this.footerContainer &&
      !!this.footerContainer.nativeElement &&
      this.footerContainer.nativeElement.childNodes.length === 0
    );
  }

  cancelHandler(): void {
    this.cancelEvent.emit();
    this.modalService.close(this.id, false);
  }

  confirmHandler(): void {
    this.confirmEvent.emit();
    this.modalService.close(this.id, true);
  }
}
